import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ChecksService } from './checks.service';
import { OneUser, User, UserData } from '../_models/users';
import { Currency } from '../_models/currency';
import { Country, OneCountry } from '../_models/country';
import { Admin, AdminRight, AllowedRightData, OneAdmin, PasswordData } from '../_models/admin';
import { DocType } from '../_models/document.type';
import { IdentityDocument } from '../_models/identityDocuments';
import { Dealslip, DealslipDashboard, OneDealslip } from '../_models/dealslip';
import { HrAdminLinkResponse, HrAnnouncement, HrAnnouncementNotification, HrDepartment, HrDesignation, HrExpense, HrLeave, HrOrganogram, HrPayroll, HrPerformance, HrReport, HrStaff, HrStaffBankAccount, OneHrAnnouncement, OneHrDepartment, OneHrDesignation, OneHrExpense, OneHrLeave, OneHrOrganogram, OneHrPayroll, OneHrPerformance, OneHrStaff, OneHrStaffBankAccount } from '../_models/hr';



@Injectable({
  providedIn: 'root'
})
export class ApiService {
  baseUrl = environment.baseUrl;
  product_key: string|number = Math.floor(Math.random() * Math.floor(999999));

  constructor(
    private http: HttpClient,
    private checkService: ChecksService
  ) {}

  private getAuthOptions(contentType: boolean = true) {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);
    var headers = {
      'Authorization': 'Bearer '+gateway_passcode,
      'key': this.product_key.toString()
    };

    if (contentType === true) {
      headers['Content-Type'] = 'application/json';
    }

    return {
      headers: new HttpHeaders(headers)
    };
  }

  // saveLocationData(locationData) {
  //     localStorage.setItem('locationData', JSON.stringify(locationData));
  // }

  /**
   * API to login User
   * @param email email address or username
   * @param password password of user
   */
  login(username, password): Observable<OneAdmin> {
    const data = {
      username,
      password
    }

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }

    const responseData = this.post(this.baseUrl + 'admin/login', JSON.stringify(data), httpOptions);

    return responseData;
  }

  password(email): Observable<PasswordData> {
    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }

    const responseData = this.get(this.baseUrl + 'admin/password/'+encodeURI(email), httpOptions);

    return responseData;
  }

  setPassword(data, token): Observable<OneAdmin> {
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/setPassword', JSON.stringify(data), httpOptions);

    return responseData;
  }

  logout(token) {
    var gateway_passcode = btoa(this.product_key + "_" + token);
    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'users/logout', httpOptions);

    return responseData;
  }

  createAdmin(data): Observable<Admin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'admin/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  modifyAdmin(data): Observable<Admin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeAdminStatus(data): Observable<OneAdmin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  resetAdminPassword(ref): Observable<OneAdmin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'admin/resetPassword/'+ref, httpOptions);

    return responseData;
  }

  deleteAdmin(ref): Observable<OneAdmin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'admin/remove/'+ref, httpOptions);

    return responseData;
  }

  listAdministrator(page:number, view:string): Observable<Admin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'admin/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  createRight(data): Observable<AdminRight> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'admin/right', JSON.stringify(data), httpOptions);

    return responseData;
  }

  modifyRight(data): Observable<AdminRight> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/right', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeRightStatus(data): Observable<AdminRight> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/right/status', JSON.stringify(data), httpOptions);

    return responseData;
  }

  deleteRight(ref): Observable<AdminRight> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'admin/right/' + ref, httpOptions);

    return responseData;
  }

  listAdminRight(): Observable<AdminRight> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'admin/right', httpOptions);

    return responseData;
  }

  getRightData(): Observable<AllowedRightData> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'admin/getData', httpOptions);

    return responseData;
  }

  setLocation(location): Observable<OneAdmin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'admin/location/'+location, httpOptions);

    return responseData;
  }

  getCountry(id:number): Observable<OneCountry> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'country/get/'+id, httpOptions);

    return responseData;
  }

  removeGallery(id:number) {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }

    const responseData = this.delete(this.baseUrl + 'content/files/'+id, httpOptions);

    return responseData;
  }

  uploadFile(id:number, file: File) {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }

    const responseData = this.post(this.baseUrl + 'content/files/'+id, formData, httpOptions);

    return responseData;
  }

  getIDs(page:number, view:string): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'identificationDocument/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  getCountries(page:number, view:string): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'country/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  createCountryArea(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'country/createArea', JSON.stringify(data), httpOptions);

    return responseData;
  }

  modifyPassword(data): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/updatePassword', JSON.stringify(data), httpOptions);

    return responseData;
  }

  modifyData(data): Observable<OneAdmin> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'admin/profile', JSON.stringify(data), httpOptions);

    return responseData;
  }

  activateProfile(data): Observable<OneUser> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'kyc/approve', JSON.stringify(data), httpOptions);

    return responseData;
  }
  
  submitApproval(data): Observable<OneUser> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'kyc/validate', JSON.stringify(data), httpOptions);

    return responseData;
  }

  createCountry(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'country/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  createID(data): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'identificationDocument/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeCountryVisibility(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/changeView', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeIDVisibility(data): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'identificationDocument/changeView', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeCountryStatus(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeIDStatus(data): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'identificationDocument/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  getCurrencies(page:number, view:string): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'country/currency/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  deleteCurrency(ref): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'country/removeCurrency/'+ref, httpOptions);

    return responseData;
  }

  getActiveCurrencies(): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'country/currency/available', httpOptions);

    return responseData;
  }

  getAssignableCurrencies(): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'country/currency/assignable', httpOptions);

    return responseData;
  }

  createCurrency(data): Observable<any> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'country/currency', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editCurrency(data): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/currency', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeCurrencyStatus(data): Observable<Currency> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/currencyStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  assignCountryCurrencies(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'country/assignCurrency', JSON.stringify(data), httpOptions);

    return responseData;
  }

  deleteArea(ref) {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'country/removeArea/'+ref, httpOptions);

    return responseData;
  }

  deleteCountry(ref): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'country/remove/'+ref, httpOptions);

    return responseData;
  }

  deleteID(ref): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'identificationDocument/remove/'+ref, httpOptions);

    return responseData;
  }

  editCountry(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editID(data): Observable<IdentityDocument> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'identificationDocument/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editCountryArea(data): Observable<Country> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'country/editArea', JSON.stringify(data), httpOptions);

    return responseData;
  }


  createDocType(data): Observable<DocType> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'documentType/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editDocType(data): Observable<DocType> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'documentType/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  deleteDocType(ref): Observable<DocType> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'documentType/remove/'+ref, httpOptions);

    return responseData;
  }

  changeDocTypeStatus(data): Observable<DocType> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'documentType/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  getDocType(page:number, view:string): Observable<DocType> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'documentType/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }




  createUser(data): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'users/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editUser(data): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'users/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  

  sendEmail(id, emailType = "kyc"): Observable<OneUser> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    if (emailType === "accountPin") {
      const responseData = this.get(this.baseUrl + 'users/sendAccountPin/'+id, httpOptions);
      return responseData;
    } else {
      const responseData = this.get(this.baseUrl + 'users/sendEmail/'+id, httpOptions);
      return responseData;
    }
  }

  deleteUser(ref): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'users/remove/'+ref, httpOptions);

    return responseData;
  }

  changeUserStatus(data): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'users/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  getOneUser(id:number): Observable<OneUser> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'users/get/'+id, httpOptions);

    return responseData;
  }

  getUser(page:number, view:string): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'users/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  getUserKyc(page:number, view:string): Observable<User> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    // request headers
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'kyc/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  createDealslip(data): Observable<OneDealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'dealslip/create', JSON.stringify(data), httpOptions);

    return responseData;
  }

  editDealslip(data): Observable<OneDealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'dealslip/edit', JSON.stringify(data), httpOptions);

    return responseData;
  }

  changeDealslipStatus(data): Observable<OneDealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.put(this.baseUrl + 'dealslip/changeStatus', JSON.stringify(data), httpOptions);

    return responseData;
  }

  deleteDealslip(ref): Observable<OneDealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.delete(this.baseUrl + 'dealslip/remove/'+ref, httpOptions);

    return responseData;
  }

  getOneDealslip(id:number): Observable<OneDealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'dealslip/get/'+id, httpOptions);

    return responseData;
  }

  getDealslip(page:number, view:string): Observable<Dealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.get(this.baseUrl + 'dealslip/get/'+view+'?page='+page, httpOptions);

    return responseData;
  }

  searchDealslip(data, page:number = 1): Observable<Dealslip> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'dealslip/search?page='+page, JSON.stringify(data), httpOptions);

    return responseData;
  }

  dealslipDashboard(data): Observable<DealslipDashboard> {
    var token = this.checkService.getToken();
    var gateway_passcode = btoa(this.product_key + "_" + token);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+gateway_passcode,
        'key': this.product_key.toString()
      })
    }
    const responseData = this.post(this.baseUrl + 'dealslip/dashboard', JSON.stringify(data), httpOptions);

    return responseData;
  }

  createHrStaff(data): Observable<OneHrStaff> {
    const responseData = this.post(this.baseUrl + 'hrStaff/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrStaff(data): Observable<OneHrStaff> {
    const responseData = this.put(this.baseUrl + 'hrStaff/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getOneHrStaff(id:number): Observable<OneHrStaff> {
    const responseData = this.get(this.baseUrl + 'hrStaff/get/'+id, this.getAuthOptions());

    return responseData;
  }

  getHrStaff(page:number = 1, view:string = ''): Observable<HrStaff> {
    const responseData = this.get(this.baseUrl + 'hrStaff/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  deleteHrStaff(ref:number): Observable<OneHrStaff> {
    const responseData = this.delete(this.baseUrl + 'hrStaff/remove/'+ref, this.getAuthOptions());

    return responseData;
  }

  suspendHrStaff(ref:number): Observable<OneHrStaff> {
    const responseData = this.put(this.baseUrl + 'hrStaff/suspend/'+ref, JSON.stringify({}), this.getAuthOptions());

    return responseData;
  }

  linkHrStaffAdmin(data): Observable<HrAdminLinkResponse> {
    const responseData = this.put(this.baseUrl + 'hrStaff/linkAdmin', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  unlinkHrStaffAdmin(data): Observable<HrAdminLinkResponse> {
    const responseData = this.put(this.baseUrl + 'hrStaff/unlinkAdmin', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  createAdminFromHrStaff(data): Observable<HrAdminLinkResponse> {
    const responseData = this.post(this.baseUrl + 'hrStaff/createAdmin', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  assignHrStaffCountries(data): Observable<OneHrStaff> {
    const responseData = this.put(this.baseUrl + 'hrStaff/assignCountries', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  uploadHrStaffPassport(id:number, file: File): Observable<OneHrStaff> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const responseData = this.post(this.baseUrl + 'hrStaff/uploadPassport/'+id, formData, this.getAuthOptions(false));

    return responseData;
  }

  uploadHrStaffResume(id:number, file: File): Observable<OneHrStaff> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);

    const responseData = this.post(this.baseUrl + 'hrStaff/uploadResume/'+id, formData, this.getAuthOptions(false));

    return responseData;
  }

  createHrDepartment(data): Observable<OneHrDepartment> {
    const responseData = this.post(this.baseUrl + 'hrDepartment/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrDepartment(data): Observable<OneHrDepartment> {
    const responseData = this.put(this.baseUrl + 'hrDepartment/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getOneHrDepartment(id:number): Observable<OneHrDepartment> {
    const responseData = this.get(this.baseUrl + 'hrDepartment/get/'+id, this.getAuthOptions());

    return responseData;
  }

  getHrDepartments(page:number = 1, view:string = ''): Observable<HrDepartment> {
    const responseData = this.get(this.baseUrl + 'hrDepartment/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  deleteHrDepartment(ref:number): Observable<OneHrDepartment> {
    const responseData = this.delete(this.baseUrl + 'hrDepartment/remove/'+ref, this.getAuthOptions());

    return responseData;
  }

  createHrDesignation(data): Observable<OneHrDesignation> {
    const responseData = this.post(this.baseUrl + 'hrDesignation/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrDesignation(data): Observable<OneHrDesignation> {
    const responseData = this.put(this.baseUrl + 'hrDesignation/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getOneHrDesignation(id:number): Observable<OneHrDesignation> {
    const responseData = this.get(this.baseUrl + 'hrDesignation/get/'+id, this.getAuthOptions());

    return responseData;
  }

  getHrDesignations(page:number = 1, view:string = ''): Observable<HrDesignation> {
    const responseData = this.get(this.baseUrl + 'hrDesignation/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  deleteHrDesignation(ref:number): Observable<OneHrDesignation> {
    const responseData = this.delete(this.baseUrl + 'hrDesignation/remove/'+ref, this.getAuthOptions());

    return responseData;
  }

  setHrOrganogram(data): Observable<OneHrOrganogram> {
    const responseData = this.post(this.baseUrl + 'hrOrganogram/set', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrOrganogram(): Observable<HrOrganogram> {
    const responseData = this.get(this.baseUrl + 'hrOrganogram/get', this.getAuthOptions());

    return responseData;
  }

  getHrOrganogramStaff(staffId:number): Observable<OneHrOrganogram> {
    const responseData = this.get(this.baseUrl + 'hrOrganogram/staff/'+staffId, this.getAuthOptions());

    return responseData;
  }

  getHrOrganogramRole(role:string): Observable<OneHrOrganogram> {
    const responseData = this.get(this.baseUrl + 'hrOrganogram/role/'+role, this.getAuthOptions());

    return responseData;
  }

  createHrStaffBankAccount(data): Observable<OneHrStaffBankAccount> {
    const responseData = this.post(this.baseUrl + 'hrStaffBankAccount/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrStaffBankAccount(data): Observable<OneHrStaffBankAccount> {
    const responseData = this.put(this.baseUrl + 'hrStaffBankAccount/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getOneHrStaffBankAccount(bankAccountRef:number): Observable<OneHrStaffBankAccount> {
    const responseData = this.get(this.baseUrl + 'hrStaffBankAccount/get/'+bankAccountRef, this.getAuthOptions());

    return responseData;
  }

  getHrStaffBankAccountList(page:number = 1): Observable<HrStaffBankAccount> {
    const responseData = this.get(this.baseUrl + 'hrStaffBankAccount/get?page='+page, this.getAuthOptions());

    return responseData;
  }

  getHrStaffBankAccounts(staffRef:number): Observable<HrStaffBankAccount> {
    const responseData = this.get(this.baseUrl + 'hrStaffBankAccount/staff/'+staffRef, this.getAuthOptions());

    return responseData;
  }

  deleteHrStaffBankAccount(bankAccountRef:number): Observable<OneHrStaffBankAccount> {
    const responseData = this.delete(this.baseUrl + 'hrStaffBankAccount/remove/'+bankAccountRef, this.getAuthOptions());

    return responseData;
  }

  createHrLeave(data): Observable<OneHrLeave> {
    const responseData = this.post(this.baseUrl + 'hrLeave/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrLeave(data): Observable<OneHrLeave> {
    const responseData = this.put(this.baseUrl + 'hrLeave/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getOneHrLeave(leaveRef:number): Observable<OneHrLeave> {
    const responseData = this.get(this.baseUrl + 'hrLeave/get/'+leaveRef, this.getAuthOptions());

    return responseData;
  }

  getHrLeaves(page:number = 1, view:string = ''): Observable<HrLeave> {
    const responseData = this.get(this.baseUrl + 'hrLeave/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  getHrStaffLeaves(staffRef:number, page:number = 1): Observable<HrLeave> {
    const responseData = this.get(this.baseUrl + 'hrLeave/staff/'+staffRef+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  getHrLeaveCalendar(data): Observable<HrLeave> {
    const responseData = this.post(this.baseUrl + 'hrLeave/calendar', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  changeHrLeaveStatus(data): Observable<OneHrLeave> {
    const responseData = this.put(this.baseUrl + 'hrLeave/changeStatus', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  deleteHrLeave(leaveRef:number): Observable<OneHrLeave> {
    const responseData = this.delete(this.baseUrl + 'hrLeave/remove/'+leaveRef, this.getAuthOptions());

    return responseData;
  }

  createHrPerformance(data): Observable<OneHrPerformance> {
    const responseData = this.post(this.baseUrl + 'hrPerformance/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrPerformance(data): Observable<OneHrPerformance> {
    const responseData = this.put(this.baseUrl + 'hrPerformance/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrPerformance(page:number = 1, view:string = ''): Observable<HrPerformance> {
    const responseData = this.get(this.baseUrl + 'hrPerformance/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  getHrStaffPerformance(staffRef:number, page:number = 1): Observable<HrPerformance> {
    const responseData = this.get(this.baseUrl + 'hrPerformance/staff/'+staffRef+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  changeHrPerformanceStatus(data): Observable<OneHrPerformance> {
    const responseData = this.put(this.baseUrl + 'hrPerformance/changeStatus', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  deleteHrPerformance(reviewRef:number): Observable<OneHrPerformance> {
    const responseData = this.delete(this.baseUrl + 'hrPerformance/remove/'+reviewRef, this.getAuthOptions());

    return responseData;
  }

  createHrPayroll(data): Observable<OneHrPayroll> {
    const responseData = this.post(this.baseUrl + 'hrPayroll/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrPayroll(data): Observable<OneHrPayroll> {
    const responseData = this.put(this.baseUrl + 'hrPayroll/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrPayroll(page:number = 1, view:string = ''): Observable<HrPayroll> {
    const responseData = this.get(this.baseUrl + 'hrPayroll/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  getHrStaffPayroll(staffRef:number, page:number = 1): Observable<HrPayroll> {
    const responseData = this.get(this.baseUrl + 'hrPayroll/staff/'+staffRef+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  changeHrPayrollStatus(data): Observable<OneHrPayroll> {
    const responseData = this.put(this.baseUrl + 'hrPayroll/changeStatus', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  deleteHrPayroll(payrollRef:number): Observable<OneHrPayroll> {
    const responseData = this.delete(this.baseUrl + 'hrPayroll/remove/'+payrollRef, this.getAuthOptions());

    return responseData;
  }

  createHrExpense(data): Observable<OneHrExpense> {
    const responseData = this.post(this.baseUrl + 'hrExpense/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrExpense(data): Observable<OneHrExpense> {
    const responseData = this.put(this.baseUrl + 'hrExpense/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrExpenses(page:number = 1, view:string = ''): Observable<HrExpense> {
    const responseData = this.get(this.baseUrl + 'hrExpense/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  searchHrExpenses(data, page:number = 1): Observable<HrExpense> {
    const responseData = this.post(this.baseUrl + 'hrExpense/search?page='+page, JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrStaffExpenses(staffRef:number, page:number = 1): Observable<HrExpense> {
    const responseData = this.get(this.baseUrl + 'hrExpense/staff/'+staffRef+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  changeHrExpenseStatus(data): Observable<OneHrExpense> {
    const responseData = this.put(this.baseUrl + 'hrExpense/changeStatus', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  deleteHrExpense(expenseRef:number): Observable<OneHrExpense> {
    const responseData = this.delete(this.baseUrl + 'hrExpense/remove/'+expenseRef, this.getAuthOptions());

    return responseData;
  }

  createHrAnnouncement(data): Observable<OneHrAnnouncement> {
    const responseData = this.post(this.baseUrl + 'hrAnnouncement/create', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  editHrAnnouncement(data): Observable<OneHrAnnouncement> {
    const responseData = this.put(this.baseUrl + 'hrAnnouncement/edit', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getHrAnnouncements(page:number = 1, view:string = ''): Observable<HrAnnouncement> {
    const responseData = this.get(this.baseUrl + 'hrAnnouncement/get/'+view+'?page='+page, this.getAuthOptions());

    return responseData;
  }

  publishHrAnnouncement(data): Observable<OneHrAnnouncement> {
    const responseData = this.put(this.baseUrl + 'hrAnnouncement/publish', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  deleteHrAnnouncement(ref:number): Observable<OneHrAnnouncement> {
    const responseData = this.delete(this.baseUrl + 'hrAnnouncement/remove/'+ref, this.getAuthOptions());

    return responseData;
  }

  getHrReportSummary(filters:any = {}): Observable<HrReport> {
    const params = new URLSearchParams();
    Object.keys(filters || {}).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && String(filters[key]) !== '') {
        params.set(key, String(filters[key]));
      }
    });
    const query = params.toString() ? '?'+params.toString() : '';
    const responseData = this.get(this.baseUrl + 'hrAnnouncement/report'+query, this.getAuthOptions());

    return responseData;
  }

  getHrAnnouncementNotifications(): Observable<HrAnnouncementNotification> {
    const responseData = this.get(this.baseUrl + 'hrAnnouncement/notification', this.getAuthOptions());

    return responseData;
  }

  markHrAnnouncementRead(ref:number = 0): Observable<HrAnnouncementNotification> {
    const path = ref > 0 ? 'hrAnnouncement/markRead/'+ref : 'hrAnnouncement/markRead';
    const responseData = this.put(this.baseUrl + path, JSON.stringify({ ref }), this.getAuthOptions());

    return responseData;
  }

  getTreasuryData(filters:any = {}): Observable<any> {
    const params = new URLSearchParams();
    Object.keys(filters || {}).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && String(filters[key]) !== '') {
        params.set(key, String(filters[key]));
      }
    });
    const query = params.toString() ? '?'+params.toString() : '';
    const responseData = this.get(this.baseUrl + 'treasury/data'+query, this.getAuthOptions());

    return responseData;
  }

  requestTreasuryAccess(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/requestAccess', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  decideTreasuryAccess(data): Observable<any> {
    const responseData = this.put(this.baseUrl + 'treasury/decideAccess', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryPair(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/pair', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryRate(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/rate', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryPosition(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/position', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryTrade(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/trade', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryBalance(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/balance', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryBalanceTransaction(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/balanceTransaction', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  saveTreasuryClosingBalance(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/closingBalance', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  toggleTreasuryPair(data): Observable<any> {
    const responseData = this.put(this.baseUrl + 'treasury/togglePair', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  settleTreasuryPosition(data): Observable<any> {
    const responseData = this.put(this.baseUrl + 'treasury/settlePosition', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  recordTreasurySwap(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'treasury/swap', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  getFinancePlData(filters:any = {}): Observable<any> {
    const params = new URLSearchParams();
    Object.keys(filters || {}).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && String(filters[key]) !== '') {
        params.set(key, String(filters[key]));
      }
    });
    const query = params.toString() ? '?'+params.toString() : '';
    const responseData = this.get(this.baseUrl + 'financePl/data'+query, this.getAuthOptions());

    return responseData;
  }

  getFinancePlStatement(filters:any = {}): Observable<any> {
    const params = new URLSearchParams();
    Object.keys(filters || {}).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && String(filters[key]) !== '') {
        params.set(key, String(filters[key]));
      }
    });
    const query = params.toString() ? '?'+params.toString() : '';
    const responseData = this.get(this.baseUrl + 'financePl/pl'+query, this.getAuthOptions());

    return responseData;
  }

  createFinanceExpense(data, file?: File): Observable<any> {
    if (file) {
      const formData: FormData = new FormData();
      Object.keys(data || {}).forEach(key => formData.append(key, data[key]));
      formData.append('file', file, file.name);
      return this.post(this.baseUrl + 'financePl/expense', formData, this.getAuthOptions(false));
    }
    const responseData = this.post(this.baseUrl + 'financePl/expense', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }

  recognizeFinanceTradeIncome(data): Observable<any> {
    const responseData = this.post(this.baseUrl + 'financePl/recognizeIncome', JSON.stringify(data), this.getAuthOptions());

    return responseData;
  }
  
  /**
   * POST Request
   * @param url API URL
   * @param jsonData JSON encoded Data
   * @param httpOptions HTTP Options
   */
  post(url, jsonData, httpOptions): Observable<any> {
    return this.http.post<any>(url, jsonData, httpOptions)
    .pipe(
      retry(1),
      catchError(this.errorHandl))
  }

  /**
   * PUT Request
   * @param url API URL
   * @param jsonData JSON encoded Data
   * @param httpOptions HTTP Options
   */
  put(url, jsonData, httpOptions): Observable<any> {
    return this.http.put<any>(url, jsonData, httpOptions)
    .pipe(
      retry(1),
      catchError(this.errorHandl))
  }

  
  /**
   * GET request
   * @param url API URL
   * @param httpOptions HTTP Options
   */
  get(url, httpOptions): Observable<any> {
    return this.http.get<any>(url, httpOptions)
    .pipe(
      retry(1),
      catchError(this.errorHandl))
  }

  
  /**
   * DELETE request
   * @param url API URL
   * @param httpOptions HTTP Options
   */
  delete(url, httpOptions): Observable<any> {
    return this.http.delete<any>(url, httpOptions)
    .pipe(
      retry(1),
      catchError(this.errorHandl))
  }

  errorHandl(error) {
    return throwError("Can not connect to service "+error);
  }
}
